var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMultiformatBundle)?_c('div',{staticClass:"indicator-container",class:{'ml-1 my-1': _vm.useDefaultMargins},attrs:{"title":_vm.$t('bundledContentFormatsHint'),"data-cy":"multiformat-bundle-indicator"}},[_c('v-icon',{class:_vm.colorClass,attrs:{"disabled":_vm.disabled}},[_vm._v("\n      filter_none\n    ")]),_vm._v(" "),_c('v-icon',{staticClass:"play-icon",class:_vm.colorClass,attrs:{"disabled":_vm.disabled}},[_vm._v("\n      play_arrow\n    ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MultiformatBundleIndicator.vue?vue&type=template&id=0f57727f&scoped=true&
// module id = 1778
// module chunks = 5